import './css/marketplace.css'
import './css/marketplace.responsive.css'

document.addEventListener(
  "DOMContentLoaded",
  () => {
    function selectFilter(filterLink) {
        var filter = filterLink.dataset.filter
        document.querySelectorAll(`[data-filter=${filter}]`).forEach(item => {
            if(item == filterLink) item.classList.toggle('selected')
            else item.classList.remove('selected')
        })
        var clearLink = document.querySelector(`a[data-action=clearfilter][data-type=${filter}]`)
        if(filterLink.classList.contains('selected')) clearLink.classList.remove('selected')
        else clearLink.classList.add('selected')
    }

    function toggleCards() {
        var selectorString = '.card'
        var tagFilterLink = document.querySelector('a.selected[data-filter=tags]')
        if(tagFilterLink) selectorString += `[data-tags~=${tagFilterLink.dataset.slug}]`
        var languageFilterLink = document.querySelector('a.selected[data-filter=languages]')
        if(languageFilterLink) selectorString += `[data-languages~=${languageFilterLink.dataset.slug}]`
        document.querySelectorAll('.card').forEach(card => {
            card.classList.remove('visible')
        })
        document.querySelectorAll(selectorString).forEach(card => {
            card.classList.add('visible')
        })
    }

    toggleCards()
    document.querySelectorAll('[data-filter]').forEach(item => {
        item.addEventListener('click', function (event) {
            selectFilter(event.target)
            toggleCards()
        })
    })
    document.querySelectorAll('a[data-action=clearfilter]').forEach(link => {
        link.addEventListener('click', function(event) {
            link.classList.add('selected')
            document.querySelectorAll(`[data-filter=${event.target.dataset.type}]`).forEach(item => {
                item.classList.remove('selected')
                toggleCards()
            })
        })
    })
  },
  false
);
